import React, { useEffect, useState } from 'react';

const LoadingEllipsis = ({ message = 'Carregando' }) => {
  const [dots, setDots] = useState('.....');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length <= 1 ? '.....' : prev.slice(0, -1)));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ fontSize: '1rem', padding: '10px', textAlign: 'left' }}>
      {message}
      <span style={{ fontWeight: 'bold', color: '#3C6809' }}>{dots}</span>
    </div>
  );
};

export default LoadingEllipsis;
